import { BodyText, theme, Subtitle } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const InstructionTextWrapper = styled.div`
  margin-top: 1.813rem;

  ${mediaQuery('md')} {
    margin-top: 4.125rem;
  }
`;

export const InstructionTitle = styled(Subtitle)`
  font-weight: ${theme.fontWeight.bold};
  color: ${theme.colors.primaryW};
  margin-bottom: 0.313rem;
`;

export const InstructionDescription = styled(BodyText)`
  color: ${theme.colors.primaryW};
  margin-bottom: 0;
`;
